/**
 * Model przechowujący procentowe stawki zwrotu (Refund Percentages) wyliczone
 * na podstawie polityki rezerwacyjnej kliniki.
 * Wykorzystywany do zasilania interfejsu decyzyjnego (Prompt) dla personelu,
 * pozwalając na szybki wybór odpowiedniego wariantu zwrotu środków dla pacjenta.
 */
export class RefundValues {

  /** Procentowa wartość zwrotu dla standardowej, regulaminowej anulacji.
   * W interfejsie użytkownika (UI) mapowana jako wariant 'REG' (Regular).
   * Reprezentuje stawkę (np. 100%), jaka przysługuje pacjentowi, gdy odwołuje
   * wizytę przed upływem granicznego czasu bezkosztowej rezygnacji.
   */
  public toa: number;

  /** Procentowa wartość zwrotu potrąconego / specjalnego.
   * W interfejsie użytkownika (UI) mapowana jako wariant 'SPECIAL'.
   * Definiuje stawkę, jaka wraca do pacjenta, gdy anulacja
   * nastąpiła po upływie wyznaczonego terminu (Expiration Date), chroniąc
   * tym samym część przychodów kliniki za zablokowanie kalendarza lekarza.
   */
  public refundAfterExpiration: number;

}
